import { ImageAnnotationLayerState } from '../../../image-annotation/state/image-annotation-state';
import { AnnotationState } from './annotation-state';

export class AnnotationState2D extends AnnotationState {
  override layers!: ImageAnnotationLayerState[];
}
